export enum InvestmentSortType {
  LastDoneShareTransactionAt = 0,
  ChangesPercentage = 1,
  LastDoneTransactionPrice = 2,
  BestBidPrice = 3,
  BestAskPrice = 4,
  OrderQuantity = 5,
  TickerCode = 6,
}
